import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadershipMember } from '../leadership.component';

@Component({
  selector: 'app-leadership-organisation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.scss', '../leadership.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrganisationComponent {
  @Input() leadershipMembers: LeadershipMember[] = [];
  @Input() selectedDesign: 'podium' | 'grid' | 'timeline' | 'magazine' | 'minimal' = 'magazine';
  @Input() organisationPagination: any = {};
  @Output() loadMore = new EventEmitter<void>();

  get topThree(): LeadershipMember[] {
    return this.leadershipMembers.filter(m => m.rank <= 3).sort((a, b) => a.rank - b.rank);
  }

  loadMoreOrganisations(): void {
    this.loadMore.emit();
  }
}

